import React from 'react';
import { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';
import { Section, SectionTitle, VerticalContactContainer } from '../styles';
import ContactInfo from './ContactInfo';

type ContactDetailsProps = {
  email: string;
  mobile?: string;
  releaseCell?: boolean;
  coopType?: SupraCoopType;
};

const LABEL_WIDTH = '80px';

const styles = {
  label: { width: LABEL_WIDTH, color: 'grey' },
};

const ContactDetails: React.FC<ContactDetailsProps> = ({
  email,
  mobile,
  releaseCell,
  coopType = SupraCoopType.PRIMARY,
}) => (
    <Section data-cy="contact-details-section">
      <VerticalContactContainer>
        <SectionTitle>Contact Details</SectionTitle>
        <ContactInfo type="email" data={email} styles={styles} />
        {(coopType === SupraCoopType.PRIMARY || releaseCell) && (
          <ContactInfo
            type="mobile"
            data={mobile}
            doNotRelease={!releaseCell}
            styles={styles}
          />
        )}
      </VerticalContactContainer>
    </Section>
  );

export default ContactDetails;
